exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-c01991b4]{\n    width: 300px;\n}\n", ""]);

// exports
